import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Avatar color palette for users without profile images
const AVATAR_COLORS = [
  { bg: "bg-red-500", hover: "hover:bg-red-600", text: "text-white" },
  { bg: "bg-orange-500", hover: "hover:bg-orange-600", text: "text-white" },
  { bg: "bg-amber-500", hover: "hover:bg-amber-600", text: "text-white" },
  { bg: "bg-yellow-500", hover: "hover:bg-yellow-600", text: "text-gray-900" },
  { bg: "bg-green-500", hover: "hover:bg-green-600", text: "text-white" },
  { bg: "bg-emerald-500", hover: "hover:bg-emerald-600", text: "text-white" },
  { bg: "bg-blue-500", hover: "hover:bg-blue-600", text: "text-white" },
  { bg: "bg-indigo-500", hover: "hover:bg-indigo-600", text: "text-white" },
  { bg: "bg-purple-500", hover: "hover:bg-purple-600", text: "text-white" },
  { bg: "bg-pink-500", hover: "hover:bg-pink-600", text: "text-white" },
];

/**
 * Generate a consistent color scheme for an avatar based on a string (name, email, etc.)
 * The color is deterministic - the same input will always produce the same color.
 */
export function getAvatarColor(identifier: string) {
  // Simple hash function to get a consistent index
  let hash = 0;
  for (let i = 0; i < identifier.length; i++) {
    const char = identifier.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  const index = Math.abs(hash) % AVATAR_COLORS.length;
  return AVATAR_COLORS[index];
}

/**
 * Get avatar color classes as a combined string for easy use
 */
export function getAvatarColorClasses(identifier: string, includeHover = true) {
  const color = getAvatarColor(identifier);
  return includeHover 
    ? `${color.bg} ${color.hover} ${color.text} transition-colors`
    : `${color.bg} ${color.text}`;
}
